import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import { SearchBarContainer } from '@search-bar/containers/search-bar/search-bar.container';
import { SearchBarDesktopComponent } from '@search-bar/components/search-bar-desktop/search-bar-desktop.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { PlacesEffects } from '@shared/base-search-bar/store/effects/places.effects';
import { PlacesService } from '@app/modules/core/services/places.service';
import { FlightDatePipe } from '@search-bar/pipes/flight-date.pipe';
import { SearchBarMobileContainer } from '@search-bar/containers/search-bar-mobile/search-bar-mobile.container';
import { SearchDataEffects } from '@shared/base-search-bar/store/effects/search-data.effects';
import { SearchDataService } from '@search-bar/services/search-data.service';
import { BaseSearchBarModule } from '@shared/base-search-bar/base-search-bar.module';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { AutocompletePlacesService } from '@search-bar/services/autocomplete-places.service';
import {
  SearchBarFlightsMobileComponent
} from '@search-bar/components/search-bar-flights-mobile/search-bar-flights-mobile.component';
import { SearchBarBusesMobileComponent } from '@search-bar/components/search-bar-buses-mobile/search-bar-buses-mobile.component';
import { SearchBarMobileService } from '@search-bar/services/search-bar-mobile.service';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { SearchIpService } from '@search-bar/services/search-ip.service';
import { ModalModule } from '@ux/components/modal/modal.module';
import { PropertiesAmplitudeService } from '@app/services/properties-amplitude.service';
import { SlidersModule } from '@shared/sliders/sliders.module';
import { SearchFlightsEffect } from '@flight-results/store/effects/search-flights.effect';
import { FlightResultsService } from '@flight-results/services/flight-results.service';
import { FlightResultsModuleState, flightResultsFeatureName } from '@flight-results/store/state/flight-results-module.state';
import { flightResultsRootReducer } from '@flight-results/store/reducers';
import { RefreshSearchFacade } from '@shared/refresh-search/store/refresh-search.facade';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { ToggleDsComponent } from '@design-system/components/molecules/toggle/toggle.component';
import { FlexDatesToggleComponent } from '@search-bar/components/flex-dates-toggle/flex-dates-toggle.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { RadioButtonDsComponent } from '@design-system/components/organisms/radio-button/radio-button.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';
import { DropDownViewModule } from '@ux/components/drop-down-view/drop-down-view.module';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

export const FEATURE_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<FlightResultsModuleState>
>('Feature Reducers');

@NgModule({
  declarations: [
    SearchBarContainer,
    SearchBarDesktopComponent,
    FlightDatePipe,
    SearchBarMobileContainer,
    SearchBarFlightsMobileComponent,
    SearchBarBusesMobileComponent,
    FlexDatesToggleComponent,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    FormsModule,
    BaseSearchBarModule,
    StoreModule.forFeature(flightResultsFeatureName, FEATURE_REDUCER_TOKEN),
    EffectsModule.forFeature([PlacesEffects, SearchDataEffects, SearchFlightsEffect]),
    SwipeUpModule,
    TranslocoModule,
    ModalModule,
    SlidersModule,
    ButtonDsComponent,
    FixedSurfaceModule,
    ToggleDsComponent,
    TypographyDsComponent,
    RadioButtonDsComponent,
    ButtonIconDsComponent,
    DropDownViewModule,
    DividerDsComponent,
    IconDsComponent,
  ],
  exports: [
    SearchBarContainer,
    SearchBarMobileContainer,
    SearchBarFlightsMobileComponent,
    SearchBarBusesMobileComponent,
    FlightDatePipe,
  ],
  providers: [
    AutocompletePlacesService,
    PlacesService,
    SearchDataService,
    FlightDatePipe,
    DatePipe,
    DomManipulateService,
    SearchBarMobileService,
    SearchIpService,
    PropertiesAmplitudeService,
    FlightResultsService,
    RefreshSearchFacade,
    {
      provide: FEATURE_REDUCER_TOKEN,
      useValue: flightResultsRootReducer,
    }
  ]
})
export class SearchBarModule { }
